export default __webpack_public_path__ + "static/media/ser8.81b056bb.svg";